import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const REVIEWS = [
  {
    name: "James Harrington",
    role: "Office Manager, Harrington & Co Solicitors",
    rating: 5,
    date: "July 2026",
    text: "Clear & Clean have been maintaining our law office for over two years now. The team is professional, discreet, and thorough. Our reception and meeting rooms always look immaculate for client visits. Highly recommended for any professional environment.",
  },
  {
    name: "Priya Mehta",
    role: "Facilities Manager, Canterbury Health Centre",
    rating: 5,
    date: "June 2026",
    text: "We engaged Clear & Clean for our healthcare facility and the standard has been exceptional. Their understanding of hygiene compliance and infection control procedures gives us complete confidence. Reliable, well-supervised, and always on time.",
  },
  {
    name: "Tom Sinclair",
    role: "Owner, Sinclair Automotive Christchurch",
    rating: 5,
    date: "June 2026",
    text: "Had the showroom deep cleaned before our annual open day. The result was outstanding — floors polished, windows spotless, every surface gleaming. Our customers actually commented on how great the place looked. Will definitely book again.",
  },
  {
    name: "Rachel O'Brien",
    role: "Principal, Westbrook Primary School",
    rating: 5,
    date: "May 2026",
    text: "Switching to Clear & Clean was one of the best decisions we made. The school is consistently clean, and the team are careful and considerate around children and staff. Their eco-friendly product options were a big plus for us.",
  },
  {
    name: "David Wu",
    role: "Property Manager, Canterbury Realty Group",
    rating: 5,
    date: "May 2026",
    text: "We use Clear & Clean for end-of-tenancy cleans across multiple properties. The turnaround is fast, the quality is consistently high, and the properties are always presented at their best. Saves us a huge amount of stress between tenancies.",
  },
  {
    name: "Sarah Thompson",
    role: "Operations Director, Thompson Logistics",
    rating: 5,
    date: "April 2026",
    text: "Our warehouse is a large and challenging space to keep clean. Clear & Clean handle it with ease — structured approach, the right equipment, and a supervisor who checks in regularly. Exactly what a business like ours needs.",
  },
  {
    name: "Mike Gallagher",
    role: "Director, Gallagher Construction Ltd",
    rating: 5,
    date: "April 2026",
    text: "Engaged Clear & Clean for a builders clean after a major commercial fit-out. They handled everything — dust, debris, glass polishing, floor treatment. The site was handed over looking absolutely pristine. Professional team from start to finish.",
  },
  {
    name: "Anjali Patel",
    role: "Store Manager, Patel Retail Group",
    rating: 5,
    date: "March 2026",
    text: "Our retail stores require a very high standard of presentation. Clear & Clean consistently deliver. The nightly cleans are thorough and the team work around our trading hours with no disruption. First impressions matter in retail, and this team gets that.",
  },
  {
    name: "Craig Bennett",
    role: "CEO, Bennett Financial Services",
    rating: 5,
    date: "March 2026",
    text: "We've tried several commercial cleaners over the years and none have matched the reliability of Clear & Clean. They show up, they do the job properly, and if we ever have a specific request they accommodate it without fuss. Excellent service.",
  },
  {
    name: "Linda Forsythe",
    role: "General Manager, Forsythe Hotel Group",
    rating: 5,
    date: "February 2026",
    text: "Clear & Clean manage the common areas and lobby of two of our properties. The standard is hotel-grade — exactly what we need. Their staff are well-presented, professional, and work quietly around our guests. We couldn't be happier.",
  },
  {
    name: "Nathan Hughes",
    role: "IT Manager, Hughes Tech Solutions",
    rating: 5,
    date: "February 2026",
    text: "We had carpet steam cleaning done across our entire office floor. The before-and-after difference was remarkable. Stains that had been there for years were completely gone. Quick service, no mess left behind, and reasonably priced.",
  },
  {
    name: "Melissa Grant",
    role: "Studio Owner, Grant Photography",
    rating: 5,
    date: "January 2026",
    text: "I needed my studio deep cleaned before a major shoot series. The team were careful with equipment, left every surface spotless, and the windows were streak-free — which matters a lot when you rely on natural light. Brilliant job.",
  },
];

const Stars = ({ count }) => (
  <span style={{ color: "#f59e0b", fontSize: 15, letterSpacing: 1 }}>
    {"★".repeat(count)}{"☆".repeat(5 - count)}
  </span>
);

const Reviews = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <>
      <Helmet>
        <title>Customer Reviews | Clear &amp; Clean Christchurch</title>
        <meta name="description" content="Read what our clients say about Clear & Clean's commercial cleaning services in Christchurch — honest reviews from offices, schools, healthcare facilities, and more." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.clearandclean.co.nz/reviews" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Clear & Clean",
          "url": "https://www.clearandclean.co.nz",
          "review": REVIEWS.map((r) => ({
            "@type": "Review",
            "author": { "@type": "Person", "name": r.name },
            "reviewRating": { "@type": "Rating", "ratingValue": r.rating, "bestRating": 5 },
            "reviewBody": r.text,
            "datePublished": r.date,
          })),
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "5.0",
            "reviewCount": REVIEWS.length,
            "bestRating": 5,
          },
        })}</script>
      </Helmet>

      {/* Hero */}
      <section
        className="hero-wrap hero-wrap-2"
        style={{ backgroundImage: 'url("/images/service_2.jpg")' }}
        data-stellar-background-ratio="0.5"
      >
        <div className="overlay" />
        <div className="container">
          <div className="row no-gutters slider-text align-items-end">
            <div className="col-md-9 pb-5">
              <p className="breadcrumbs mb-2">
                <span className="mr-2">
                  <Link to="/">Home <i className="fa fa-chevron-right" /></Link>
                </span>
                <span>Reviews <i className="fa fa-chevron-right" /></span>
              </p>
              <h1 className="mb-0 bread">Customer Reviews</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Aggregate banner */}
      <section style={{ background: "#1a1a1a", padding: "28px 0" }}>
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-md-6">
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 16, flexWrap: "wrap" }}>
                <div>
                  <div style={{ fontSize: 42, fontWeight: 800, color: "#fff", lineHeight: 1 }}>5.0</div>
                  <Stars count={5} />
                  <div style={{ color: "#aaa", fontSize: 13, marginTop: 4 }}>Based on {REVIEWS.length} reviews</div>
                </div>
                <div style={{ width: 1, height: 60, background: "#333" }} />
                <div style={{ color: "#ccc", fontSize: 14, maxWidth: 240, textAlign: "left" }}>
                  Trusted by offices, schools, healthcare facilities, and businesses across Christchurch.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Reviews grid */}
      <section className="ftco-section" style={{ background: "#f9fafb" }}>
        <div className="container">
          <div className="row justify-content-center pb-4">
            <div className="col-md-8 text-center">
              <span className="subheading">Testimonials</span>
              <h2>What Our Clients Say</h2>
            </div>
          </div>

          <div className="row">
            {REVIEWS.map((r, i) => (
              <div key={i} className="col-md-6 col-lg-4 mb-4">
                <div style={{
                  background: "#fff", borderRadius: 12, padding: "24px",
                  height: "100%", boxShadow: "0 2px 12px rgba(0,0,0,.06)",
                  display: "flex", flexDirection: "column",
                }}>
                  <Stars count={r.rating} />
                  <p style={{
                    color: "#444", fontSize: 14, lineHeight: 1.75,
                    margin: "14px 0 20px", flex: 1,
                  }}>
                    "{r.text}"
                  </p>
                  <div style={{ borderTop: "1px solid #f3f4f6", paddingTop: 14 }}>
                    <div style={{ fontWeight: 700, fontSize: 14, color: "#1a1a1a" }}>{r.name}</div>
                    <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>{r.role}</div>
                    <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>{r.date}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="row justify-content-center mt-4">
            <div className="col-md-7 text-center">
              <p style={{ color: "#666", marginBottom: 16 }}>
                Ready to experience the Clear &amp; Clean difference?
              </p>
              <Link to="/contact" className="btn btn-dark px-4 py-2 mr-3">
                Get a Free Quote
              </Link>
              <a href="tel:+64220866040" className="btn btn-outline-dark px-4 py-2">
                <i className="fa fa-phone mr-2" />+64 22 086 6040
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Reviews;
